module.exports = __webpack_public_path__ + "Bronze-7ccf9d622216746a8a252060325e6955.png";